import ShiftSimpleVisualization from "./objectSimpleVisualizations/Shift.vue"

export default {
    definition: {
        "UserDB": {
            links: {
                show: '/user/*',
                edit: '/user/*/edit',
            }
        },
        "ManualShiftDB": {
            links: {
                timechecker: '/shiftReport/*',
                edit: '/schedule/shift/*/edit'
            },
            hasViewsLog: true,
            visualizationComponent: ShiftSimpleVisualization
        },
        "ManualExtraShiftDB": {
            links: {
                timechecker: '/shiftReport/*',
                edit: '/schedule/shift/*/edit'
            },
            hasViewsLog: true,
            visualizationComponent: ShiftSimpleVisualization
        },
        "LeaveDB": {
            links: {
                show: '/leave/*',
            },
            hasViewsLog: true
        },
        "DiskFileDB": {
            links: {
                edit: '/disk/file/*/edit',
                show: '/disk/file/*',
            },
            hasViewsLog: true
        },
        DiskDirectoryDB: {
            links: {
                edit: '/disk/directory/*/edit',
                show: '/disk/directory/*',
            }
        },
        CommissionProductDB: {
            links: {
                edit: '/commissionProduct/*/edit',
                show: '/commissionProduct/*',
            }
        },
        EvaluationPollDB: {
            links: {
                show: '/evaluation/poll/*',
            },
            hasViewsLog: true
        },
        WorkersAvailabilitySlotDB: {
            links: {
                edit: '/workersAvailability/*/edit',
                show: '/workersAvailability/*',
            }
        }
    },
    parseLink(link) {
        for (const objectType in this.definition) {
            for (const linkType in this.definition[objectType].links) {
                const pattern = this.definition[objectType].links[linkType];
                if (pattern.split('*').length === 2) {
                    const prefix = pattern.split('*')[0];
                    const suffix = pattern.split('*')[1];
                    if (link.startsWith(prefix) && link.endsWith(suffix)) {
                        const id = link.slice(prefix.length, link.length - suffix.length);
                        if (+id) {
                            return {
                                id: +id,
                                objectType: objectType
                            }
                        }
                    }
                }
            }
        }
        return null;
    }
}
